import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import { useState } from 'react'
import { UseFormSetError } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { ErrorResponse, LoginForm } from 'routes/selfcare/SelfcareLogin/types'

export const useHandleError = (setFormError: UseFormSetError<LoginForm>) => {
    const { formatMessage } = useIntl()
    const [errorMessage, setErrorMessage] = useState<string | null>(null)

    const handleError = (error: FetchBaseQueryError | SerializedError) => {
        if (!('status' in error)) return

        const errorData = error.data as ErrorResponse
        const statusCode = error.status

        setFormError('email', { type: 'server' })
        setFormError('paymentNumber', { type: 'server' })

        const defaultErrorMsg = formatMessage({
            id: 'selfcare.login.general_error',
            defaultMessage: '_',
        })

        switch (statusCode) {
            case 404:
            case 422:
                setErrorMessage(errorData.error)
                break
            case 409:
                if (errorData.code === 1011 || errorData.code === 1010) {
                    setErrorMessage(errorData.error)
                } else {
                    setErrorMessage(defaultErrorMsg)
                }
                break
            default:
                setErrorMessage(defaultErrorMsg)
        }
    }

    return { handleError, setErrorMessage, errorMessage }
}
